import {
  type ReconcileSessionStatus,
  ReconcileSessionStatuses,
} from '../enums/ReconcileSessionStatusEnum'
import {
  SessionLockStatus,
  type SessionLockStatusConstructor,
} from '../SessionLockStatus'

export interface ReconcileSessionConstructor {
  id: number
  uuid: string
  status: ReconcileSessionStatus
  balance: string // decimal string, e.g. "4500.00" — ending balance
  statementDate: Nullable<ISODateString>
  lockStatus: SessionLockStatusConstructor
  billUuid: Nullable<string> // populated once SUBMITTED
  billGroup: Nullable<number> // "BILL #{group}" label source
  creditcardId: number
}

export class ReconcileSession {
  readonly id: number
  readonly uuid: string
  readonly status: ReconcileSessionStatus
  readonly balance: string
  readonly statementDate: Nullable<Date>
  readonly lockStatus: SessionLockStatus
  readonly billUuid: Nullable<string>
  readonly billGroup: Nullable<number>
  readonly creditcardId: number

  constructor(data: ReconcileSessionConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.status = data.status
    this.balance = data.balance
    this.statementDate = data.statementDate
      ? new Date(data.statementDate)
      : null
    this.lockStatus = new SessionLockStatus(data.lockStatus)
    this.billUuid = data.billUuid
    this.billGroup = data.billGroup
    this.creditcardId = data.creditcardId
  }

  get isDraft(): boolean {
    return this.status === ReconcileSessionStatuses.DRAFT
  }

  get isSubmitted(): boolean {
    return this.status === ReconcileSessionStatuses.SUBMITTED
  }

  // Ending balance as a number for variance math (BHV-035/036)
  get balanceValue(): number {
    return parseFloat(this.balance)
  }

  // "BILL #131" status action label (BHV-009)
  get billNumberLabel(): Nullable<string> {
    return this.billGroup !== null ? `BILL #${this.billGroup}` : null
  }
}
